<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="q-py-sm">
            <div class="crud-title">
              <translate>VIEW_REGISTRATION</translate>
            </div>
          </q-card-section>
          <q-card-section class="q-px-lg">
            <jt-dynamic-form
              ref="dynamicForm"
              :inputs="elements[0].inputs"
              :relacionamentos="elements[0].relacionamentos"
              :model="elements[0].dadosForm"
              :interface="elements[0].nmInterface"
              form-class="form dynamic"
            />
          </q-card-section>
        </q-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDynamicForm } from 'jtech-webcomps'
import { repository } from 'jtech'
const { page } = JtCrud
@Component({
  mixins: [page],
  name: 'ConsentLetterDetailPage',
  components: { JtDynamicForm, page },
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }
})
class ConsentLetterDetailPage extends Vue {
}
export default ConsentLetterDetailPage
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

</style>
